<template>
  <div class="form-out-view">
    <!-- //添加修改基本信息 -->
    <UserTitle :title="title"></UserTitle>
    <a-form :form="form" @submit="handleSubmit" class="form-all">
      <b-row>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="学历认证号">
            <a-input v-decorator="['number']" />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="就读专业">
            <a-input
              v-decorator="[
                'major',
                {
                  rules: [{ required: true, message: '请填写就读专业' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>

        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="就读院校">
            <a-input
              v-decorator="[
                'college',
                {
                  rules: [{ required: true, message: '请填写就读院校' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>

        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="学历名称">
            <!-- <a-input
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '请输入学历名称' }]
                }
              ]"
            /> -->
            <a-select
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '请选择学历' }]
                }
              ]"
            >
              <a-select-option value="博士">博士</a-select-option>
              <a-select-option value="硕士">硕士</a-select-option>
              <a-select-option value="本科">本科</a-select-option>
              <a-select-option value="大专">大专</a-select-option>
              <a-select-option value="高中">高中</a-select-option>
              <a-select-option value="中专/中技">中专/中技</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="学历类型">
            <a-select v-decorator="['type']">
              <a-select-option value="全日制">全日制</a-select-option>
              <a-select-option value="非全日制">非全日制</a-select-option>
            </a-select>
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="国家">
            <a-input v-decorator="['country']" />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="城市">
            <a-input v-decorator="['city']" />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="入学时间">
            <a-date-picker
              style="width:100%"
              placeholder="请选择入学时间"
              v-model="startValue"
              :disabled-date="disabledStartDate"
              v-decorator="[
                'enterTime',
                {
                  rules: [{ required: true, message: '请填写入学时间' }]
                }
              ]"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-left-view">
          <a-form-item label="学校类别">
            <a-input
              v-decorator="['collegeClass']"
              placeholder="双一流/985/211"
            />
          </a-form-item>
        </b-col>
        <b-col cols="12" md="6" class="form-right-view">
          <a-form-item label="毕业时间">
            <a-date-picker
              style="width:100%"
              placeholder="请选择毕业时间"
              v-model="endValue"
              :disabled-date="disabledEndDate"
              v-decorator="['graduationTime']"
            />
          </a-form-item>
        </b-col>
        <a-form-item class="form-footer">
          <a-button class="success-button usually-button" html-type="submit"
            >保存</a-button
          >
          <a-button class="disable-button usually-button" @click="goBack"
            >取消</a-button
          >
        </a-form-item>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      startValue: null,
      endValue: null,
      id: this.$route.query.id || 0,
      type: this.$route.query.type || "add",
      title: "编辑教育经历",
      loading: false,
      imageUrl: "",
      form: this.$form.createForm(this, {
        name: "educationForm"
      }),
      options: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    login() {
      return publicChange.userLogin();
    },
    async getData() {
      const login = this.login();
      if (login) {
        if (this.type == "edit" && this.id !== 0) {
          this.title = "修改教育经历";
          const eduction = await Api.User.getEductionDetail(this.id);
          if (eduction) {
            this.$nextTick(() => {
              this.form.setFieldsValue({
                number: eduction.number,
                college: eduction.college,
                major: eduction.major,
                country: eduction.country,
                city: eduction.city,
                collegeClass: eduction.collegeClass,
                type: eduction.type,
                name: eduction.name,
                enterTime: this.$moment(eduction.enterTime) || null,
                graduationTime: this.$moment(eduction.graduationTime) || null
              });
            });
          }
        } else if (this.type == "add") {
          this.title = "新增教育经历";
        } else {
          this.$message.error("获取页面错误，请重新进入页面");
          this.$router.push("/user/talent");
        }
      } else {
        this.$router.push({
          path: "/login",
          query: { redirect: location.href }
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        let data = {
          ...values,
          enterTime: this.$moment(values.enterTime) || null,
          graduationTime: this.$moment(values.graduationTime) || null
        };
        if (!err) {
          if (this.type == "edit") {
            const education = await Api.User.EditEducation(data, this.id);
            if (education) {
              this.$message.success("修改成功");
              this.goBack();
            } else {
              this.$message.error("修改失败");
            }
          } else {
            const education = await Api.User.CreateEducation(data);
            if (education) {
              this.$message.success("添加成功");
              this.goBack();
            } else {
              this.$message.error("添加失败");
            }
          }
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    //处理地区
    onChange(value) {
      this.areaDefaultValue = value;
    }
  }
};
</script>
<style scoped></style>
